import { render } from "./ConsultationForm.vue?vue&type=template&id=4395e356&scoped=true"
import script from "./ConsultationForm.vue?vue&type=script&lang=js"
export * from "./ConsultationForm.vue?vue&type=script&lang=js"

import "./ConsultationForm.vue?vue&type=style&index=0&id=4395e356&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4395e356"]])

export default __exports__